// extracted by mini-css-extract-plugin
module.exports = {"skeleton":"skeleton_skeleton__PxLik","blok-big-title":"skeleton_blok-big-title__vHvIR","blok-title":"skeleton_blok-title__Tx_VF","blok-subtitle":"skeleton_blok-subtitle__lDYip"};